module.exports = __webpack_public_path__ + "img/mary.02a99b5b.png";